exports.f = require('./_wks');



//////////////////
// WEBPACK FOOTER
// /Users/JOTO/Documents/www/herok-2017/site/node_modules/core-js/modules/_wks-ext.js
// module id = ../../node_modules/core-js/modules/_wks-ext.js
// module chunks = 0